import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Icon, Table } from 'antd';
import _ from "i18n";
import { formatAmount, showErrorNotification, formatDate } from "../../../services/utils";
import { getBankwires } from "../../../actions/thunks/mangoPay";
import { get } from "lodash";

const BankwiresDatatable = ({ currentClient, getBankwires }) => {

  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isError, setIsError] = useState(false);


  const columns = [
    {
      title: _("Date"),
      dataIndex: "CreationDate",
      align: "left",
      render: timestamp => formatDate(timestamp)
    },
    {
      title: _("Tag"),
      dataIndex: "Tag",
      align: "left",
    },
    {
      title: _('amount'),
      dataIndex: "PaymentDetails.DeclaredDebitedFunds.Amount",
      align: "left",
      render: amount => formatAmount(amount)

    },
    {
      title: _("status"),
      dataIndex: "Status",
      align: "left",
      render: status => {
        return (
          <div className={"flex items-center"}>
            {getRowStatusIcon(status)}
            <span className={'capitalize'}>{getRowStatus(status)}</span>
          </div>
        );
      }
    },
  ];

  useEffect(() => {
    loadgetBankwires();
  }, []);

  const loadgetBankwires = () => {
    setIsFetching(true);
    getBankwires(currentClient.id).then((res) => {
      const resp = res.data.data;
      const sortedData = resp.sort((a, b) => new Date(b.CreationDate) - new Date(a.CreationDate))
      setData(sortedData);
    }).catch((err) => {
      showErrorNotification(_('error'), _('errorOccured'));
    }).finally(() => setIsFetching(false))
  }

  const getRowStatusIcon = (status) => {

    const icons = {
      SUCCEEDED: <Icon type="check-circle" style={{ marginRight: '5px', color: "#06D9B1" }} />,
      FAILED: <Icon type="close-circle" style={{ marginRight: '5px', color: "#FE3745" }} />,
      CREATED: <Icon type="plus-circle" style={{ marginRight: '5px' }} />,
    };

    return icons[status] || null;
  };

  const getRowStatus = (logType) => {
    const status = {
      SUCCEEDED: _('SUCCESS'),
      FAILED: _('error'),
      CREATED: "créé",
    }

    return status[logType] || null;
  };
 
    return <div className={"flex items-center"}
      style={{ "padding": "1.5rem", "height": "100%" }}>
      <div className={"bankwires-datatable-container"} style={{ "width": "100%" }}>
        <div className={'bankwires-datatable-title mb-4'}>
          {_("CREATED_BANKWIRES")}
        </div>
        <Table
          rowKey="Id"
          columns={columns}
          loading={isFetching}
          className="bankwires-datatable"
          pagination={{ pageSize: 6 }}
          dataSource={data}
        />
      </div>

    </div>;
}


const mapStateToProps = state => ({
  currentClient: state.auth.currentClient,
});

const mapDispatchToProps = {
  getBankwires,
};

export default connect(mapStateToProps, mapDispatchToProps)(BankwiresDatatable);




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/BankwiresDatatable.js